import { render, staticRenderFns } from "./BannerView.vue?vue&type=template&id=aa56b966&scoped=true&"
import script from "./BannerView.vue?vue&type=script&lang=js&"
export * from "./BannerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa56b966",
  null
  
)

export default component.exports